import { Link, Navigate, useLocation } from "react-router-dom";
import { useSeo } from "@/lib/seo";

// Liens recopiés avec une ponctuation collée (« /boutique, », « /,/ » vus dans Search Console) : retour vers la vraie page.
const cleanPath = (p) => (p.replace(/[,;.!)\]»"']+(?=\/|$)/g, "").replace(/\/{2,}/g, "/").replace(/(.)\/$/, "$1") || "/");

export default function NotFound() {
  const { pathname, search } = useLocation();
  const clean = cleanPath(pathname);
  useSeo({ title: "Page introuvable | Ozentya", noindex: true });
  if (clean !== pathname) return <Navigate to={`${clean}${search}`} replace />;
  return (
    <main data-testid="not-found-page" className="mx-auto flex min-h-[70vh] max-w-3xl flex-col items-start justify-center px-5 pt-40 pb-24 md:px-10">
      <p className="eyebrow mb-4">Erreur 404</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl">Cette page n'existe pas.</h1>
      <p className="mt-6 text-base text-[var(--parchment)]/85">Elle a peut-être été déplacée. Voici où continuer :</p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/" data-testid="not-found-home" className="rounded-full bg-[var(--gold)] px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ink)]">Accueil</Link>
        <Link to="/boutique" data-testid="not-found-shop" className="rounded-full border border-[var(--gold)] px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--gold-soft)]">Boutique</Link>
        <Link to="/cheveux-afro-crepus" data-testid="not-found-guide" className="rounded-full border border-[var(--line)] px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em]">Guide cheveux afro</Link>
      </div>
    </main>
  );
}
